import type {DisplayType, PublishingPurchaseErrorStatus, Status} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.types';

export interface PublishingEmbedInWebpagePanelProps {
  displayType: DisplayType;
}

export interface PublishingEmbedResponseProps {
  htmlsnippet: string;
  htmlSnippet: string;
  userAddedLink: boolean;
  hasUserAddedEmbedLink: boolean;
  isPosterEnabled: boolean;
  customizableLink: string;
}

export interface AJAXResponseOrderSuccess {
  type: string;
  isRealTime: boolean;
  idOrder: string | null;
}

export interface AJAXResponseOrderGenerationStatus {
  percentageDone: number;
  heaviness: string;
  estimatedTimeInSeconds: number;
  estimatedTimeStr: string;
  idProduct: string;
  error: string | null;
}

export interface OrderDetailsForRedux {
  progressPercentage: number;
  estimatedTimeInSeconds: string;
  timeElapsedInSeconds: number;
  error: string;
}

export interface Checkout {
  doUpsellPremium: boolean;
  id: string;
  idProduct: string;
  posterHash: string;
  price: string;
  priceId: number;
  rawPrice: number;
  summary: Summary;
  orderTotal: number;
  paidProduct: PaidProduct;
  url: string;
  is: boolean;
  cb: (data: AJAXResponseOrderSuccess) => void;
  onCloseCallBack: () => void;
}

export interface Summary {
  freeProducts: string[];
}

export interface PaidProduct {
  name: string;
  price: number;
}

export interface AJAXResponsePurchaseProduct {
  error: number;
  orderRegen: boolean;
  premium: number;
  isPremiumUser: number;
  status?: Status;
  url: string;
  checkout: Checkout;
  message: [];
  premiumPurchase?: PremiumPurchase;
}

interface PremiumPurchase {
  idProduct: number;
  creditPrice?: string;
}

export interface AJAXResponseOutOfFreeDownloads {
  ga4PurchaseEventParams: PurchaseEventParams;
  idSubscriptionPurchase: string;
  invoiceId: string;
  isPaymentIntentSuccessful: boolean;
  orderValue: number;
}

interface PurchaseEventParams {
  currency: string;
  transaction_id: string;
  location_id: string;
  value: number;
  tax: number;
  items: PurchaseItemParams[];
}

interface PurchaseItemParams {
  currency: string;
  item_category: string;
  item_id: number;
  item_name: string;
  location_id: string;
  price: number;
  quantity: number;
}

export interface VideoFreebieParams {
  isAvailable: boolean;
}

export interface AJAXResponseForOrderError {
  code: PublishingPurchaseErrorStatus;
}

export const MAX_LINK_LENGTH = 100;
